import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import s from './styles.module.scss'

interface Props {
  passengersNames?: string
}

export const BlackListModal = ({ passengersNames }: Props) => {
  const { t } = useTranslation()

  const { closeDialog } = useDialogBottomSheet()

  const title = passengersNames
    ? t('black_list.modal_title_pass', { passengersNames })
    : t('black_list.modal_title')

  return (
    <div className={s.container}>
      <div className={s.info}>
        <p className={clsx(s.title, 'bold-20')}>{title}</p>
        <p className={clsx('regular-14', s.text)}>
          {t('black_list.modal_subtitle')}
        </p>
      </div>

      <Button
        onClick={closeDialog}
        className={s.btn}
      >
        {t('ok')}
      </Button>
    </div>
  )
}
